
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8D7c3", function(module, exports) {
const $9c67d6e83108154f$export$acd187a38a2cd68a = 'confluence:twcg-2055:flag-to-share-action';
const $9c67d6e83108154f$export$f28869dd2aadb934 = (detail)=>{
    const browserWindow = globalThis.document?.defaultView;
    if (!browserWindow) return false;
    const actionEvent = new CustomEvent($9c67d6e83108154f$export$acd187a38a2cd68a, {
        cancelable: true,
        detail: detail
    });
    browserWindow.dispatchEvent(actionEvent);
    return actionEvent.defaultPrevented;
};
module.exports["CONFLUENCE_FLAG_TO_SHARE_ACTION_EVENT"] = $9c67d6e83108154f$export$acd187a38a2cd68a;
module.exports["dispatchConfluenceFlagToShareAction"] = $9c67d6e83108154f$export$f28869dd2aadb934;

});

parcelRegister("3jRrs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $3PNw6 = parcelRequire("3PNw6");

const $7f8675ab969ce2e0$export$e275bea1043f4431 = ()=>{
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInConfluenceHoldout = (0, $cXtTj.default).initializeCompleted() && !(0, $cXtTj.default).checkGate('product-confluence-holdout-observability-gate', {
        fireGateExposure: false
    });
    return {
        holdout: isInConfluenceHoldout ? 'confluence-holdout' : ''
    };
};
const $7f8675ab969ce2e0$export$c7fd2161616b0849 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: $7f8675ab969ce2e0$export$e275bea1043f4431()
    });
};
module.exports["getIsInConfluenceHoldoutData"] = $7f8675ab969ce2e0$export$e275bea1043f4431;

});

parcelRegister("hkzol", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kTb7m = parcelRequire("kTb7m");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cleanupCopiedTimer = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $cozmU.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $cozmU.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $cozmU.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip,
        __callerPackage__: "copy-content-link"
    });
    const makeContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            case 'folder':
                routeName = (0, $1NBp8.FOLDER_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<0b2f5f44bd64ba7831c6ee7b039fb54f>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("jooGc", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $8s9DV.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $kBr4q.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $kBr4q.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("kd4L2"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("kd4L2", function(module, exports) {

let $eb68b650f9c1ad8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb68b650f9c1ad8a$var$load("gkVge"),
    $eb68b650f9c1ad8a$var$load("kVHWO"),
    $eb68b650f9c1ad8a$var$load("amPsT"),
    $eb68b650f9c1ad8a$var$load("c831e"),
    $eb68b650f9c1ad8a$var$load("LWh5V"),
    $eb68b650f9c1ad8a$var$load("l3CW5"),
    $eb68b650f9c1ad8a$var$load("30b92"),
    $eb68b650f9c1ad8a$var$load("ksOjm"),
    $eb68b650f9c1ad8a$var$load("jAsJw"),
    $eb68b650f9c1ad8a$var$load("90SZm"),
    $eb68b650f9c1ad8a$var$load("crfrC"),
    $eb68b650f9c1ad8a$var$load("4x9Jx"),
    $eb68b650f9c1ad8a$var$load("ea3NB"),
    $eb68b650f9c1ad8a$var$load("6wr18"),
    $eb68b650f9c1ad8a$var$load("59hV4"),
    $eb68b650f9c1ad8a$var$load("fuOfV"),
    $eb68b650f9c1ad8a$var$load("jL1Ke"),
    $eb68b650f9c1ad8a$var$load("5MQ0D"),
    $eb68b650f9c1ad8a$var$load("ffEVr"),
    $eb68b650f9c1ad8a$var$load("fwbNS"),
    $eb68b650f9c1ad8a$var$load("zUKwV"),
    $eb68b650f9c1ad8a$var$load("fUeur"),
    $eb68b650f9c1ad8a$var$load("h4Nf7"),
    $eb68b650f9c1ad8a$var$load("Wowvf"),
    $eb68b650f9c1ad8a$var$load("4g6rd"),
    $eb68b650f9c1ad8a$var$load("hhss7"),
    $eb68b650f9c1ad8a$var$load("7EorR"),
    $eb68b650f9c1ad8a$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$3f89eb51f735e9b3 = [
    'page'
];
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["ACCESS_LINK_ENROLLED_CONTENT_TYPES"] = $73fa77a308d85fef$export$3f89eb51f735e9b3;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("4Ewfm", function(module, exports) {

var $fg72c = parcelRequire("fg72c");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ generalAccess: generalAccess, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ generalAccess: generalAccess, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
function $b2ff9ab7087360b2$export$49bcbf98a41d5666({ generalAccess: generalAccess, principals: principals }) {
    const restrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
    const gqlInput = {
        read: restrictions.read,
        update: restrictions.update
    };
    gqlInput.restrictionState = (0, $fg72c.generalAccessLevelToMode)(generalAccess);
    gqlInput.permissions = $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, generalAccess);
    return gqlInput;
}
/**
 * Builds the flat permissions array format (view/edit) from the principals map.
 * This is the new format used by the permissions + restrictionState fields on ConfluenceContentInput.
 *
 * Unlike the old restrictions format (read/update with separate user/group arrays),
 * this produces flat arrays of { id, type } objects for view and edit.
 */ function $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, _generalAccess) {
    const viewList = [];
    const editList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const principalType = principal.type === 'user' ? 'USER' : 'GROUP';
        // Add can-view principals to view list
        if (role === 'can-view') viewList.push({
            id: principal.id,
            type: principalType
        });
        // Add can-edit principals to edit list only
        if (role === 'can-edit') editList.push({
            id: principal.id,
            type: principalType
        });
    }
    return {
        view: viewList,
        edit: editList
    };
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ generalAccess: generalAccess, principals: principals, restrictionType: restrictionType }) {
    switch(generalAccess){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            // instead of type: 'user'
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;
module.exports["getGqlRestrictionsInputForPublishModal"] = $b2ff9ab7087360b2$export$49bcbf98a41d5666;

});

parcelRegister("fg72c", function(module, exports) {
const $06bae8500a7e571b$export$406c89e51172952a = {
    restricted: 'VIEW_RESTRICTED',
    'open-can-view': 'EDIT_RESTRICTED',
    'open-can-edit': 'OPEN'
};
const $06bae8500a7e571b$export$3e8e3eee6dfccab0 = (level)=>$06bae8500a7e571b$export$406c89e51172952a[level];
module.exports["generalAccessLevelToMode"] = $06bae8500a7e571b$export$3e8e3eee6dfccab0;

});

parcelRegister("8oEoE", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("7QoAs", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $d9tcB = parcelRequire("d9tcB");


var $fdPUP = parcelRequire("fdPUP");


var $4Ewfm = parcelRequire("4Ewfm");


var $22cFL = parcelRequire("22cFL");


var $jI7Td = parcelRequire("jI7Td");

const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        const { data: usersContentAccessData, error: usersContentAccessError } = await (0, $c0rhi.queryInterop)({
            query: (0, $jI7Td.default),
            variables: {
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (usersContentAccessError) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessError.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: 'USER'
            };
            return blockedAccessSubject;
        });
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $22cFL.default),
            variables: {
                // The GraphQL query expects a number, but contentId is a string. For the relay migration we will type it as any to not break existing functionality,
                // but this should be fixed in the future and keep the types consistent.
                contentId: contentId,
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (error) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: error?.message
            }
        });
        const blockedAccessRestrictions = data?.blockedAccessRestrictions;
        const blockedAccessRestrictionSummary = blockedAccessRestrictions?.blockedAccessRestrictionSummary;
        if (blockedAccessRestrictions && blockedAccessRestrictionSummary && blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("22cFL", function(module, exports) {
/**
 * @generated SignedSource<<75c554d8ad4e342d8666c6b62aee9b86>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed
const $855873b1252722a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjects"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "subjectId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "subjects",
                    "variableName": "subjects"
                }
            ],
            "concreteType": "BlockedAccessRestrictions",
            "kind": "LinkedField",
            "name": "blockedAccessRestrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SubjectRestrictionHierarchySummary",
                    "kind": "LinkedField",
                    "name": "blockedAccessRestrictionSummary",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "BlockedAccessSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "subjectType"
                                }
                            ]
                        },
                        {
                            "concreteType": "RestrictedResource",
                            "kind": "LinkedField",
                            "name": "restrictedResources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceTitle"
                                },
                                {
                                    "concreteType": "RestrictedResourceLinks",
                                    "kind": "LinkedField",
                                    "name": "resourceLink",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "base"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUi"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredAccessType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "BlockedAccessEmpowerment",
                    "kind": "LinkedField",
                    "name": "blockedAccessEmpowerment",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCurrentUserEmpowered"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
                    "kind": "LinkedField",
                    "name": "blockedAccessAssignableSpaceRolesIntersection",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "canFixRestrictionsForAllSubjects"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
            "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
            "metadata": {},
            "name": "BlockedAccessRestrictionsQuery",
            "operationKind": "query",
            "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
        }
    };
}();
$855873b1252722a0$var$node.hash = "cc9731fa07afd21d30e45e70eeb338f4";
var $855873b1252722a0$export$2e2bcd8739ae039 = $855873b1252722a0$var$node;
module.exports["default"] = $855873b1252722a0$export$2e2bcd8739ae039;

});

parcelRegister("jI7Td", function(module, exports) {
/**
 * @generated SignedSource<<bc99a62c4eb8102fc854786a36828b06>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9
const $b86f4f4db61ac40f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceUserContentAccessResult",
            "kind": "LinkedField",
            "name": "confluence_userContentAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAccessList"
                },
                {
                    "kind": "ScalarField",
                    "name": "cannotAccessList"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "727771f625528321882e822398d219fd",
            "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
            "metadata": {},
            "name": "UsersContentAccessQuery",
            "operationKind": "query",
            "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
        }
    };
}();
$b86f4f4db61ac40f$var$node.hash = "3af84917efe0ce91f68b18f96d2f126c";
var $b86f4f4db61ac40f$export$2e2bcd8739ae039 = $b86f4f4db61ac40f$var$node;
module.exports["default"] = $b86f4f4db61ac40f$export$2e2bcd8739ae039;

});

parcelRegister("f2UnK", function(module, exports) {

var $8NGcs = parcelRequire("8NGcs");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $8NGcs.default);
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (0, $dYU3e.query)({
        query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "share-and-restrict-dialog"
    }).then(({ data: data, hasErrors: hasErrors })=>{
        if (hasErrors) // Handle errors silently for preloading
        return null;
        return data?.confluence_spaceRoleMode || null;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    });
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("8NGcs", function(module, exports) {
/**
 * @generated SignedSource<<bbbcf040ac95e90832074d5908ee571b>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4
const $556eda7e15abe5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4c198432b204cbcb18fb5160733adf98",
            "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
            "metadata": {},
            "name": "preloadSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$556eda7e15abe5d2$var$node.hash = "1b6118c2bdcdd04e86f799370c9c7bca";
var $556eda7e15abe5d2$export$2e2bcd8739ae039 = $556eda7e15abe5d2$var$node;
module.exports["default"] = $556eda7e15abe5d2$export$2e2bcd8739ae039;

});


//# sourceMappingURL=render.a2893ab5.js.map
